import api from '@/services/api'

export default {
  fetchLists(data) {
    return api.get(`lists/`, {params: data})
              .then(response => response.data)
  },
  fetchList(list_id) {
    return api.get(`lists/${list_id}/`)
              .then(response => response.data)
  },
  createList (list) {
    return api.post(`lists/`, {
      name: list.name,
      content_type: list.content_type,
      items: [],
      public: list.public
    })
    .then(response => response.data)
  },
  copyList (list) {
    return api.post('lists/', {
      name: list.name,
      content_type: list.content_type,
      items: list.items,
    })
  },
  saveList(list_id, items) {
    return api.patch(`lists/${list_id}/`, {items: items})
              .then(response => response.data)
  },
  editList(list) {
    return api.patch(`lists/${list.id}/`, {name: list.name, public: list.public})
              .then(response => response.data)
  },
  deleteList(list_id) {
    return api.delete(`lists/${list_id}/`)
              .then(response => response.data)
  },
  editItem(list_id, item) {
    return api.post(`lists/${list_id}/items/${item.id}/`, item)
              .then(response => response.data)
  },
  deleteItem(list_id, item_id) {
    return api.delete(`lists/${list_id}/items/${item_id}/`)
              .then(response => response.data)
  }
}